import React, { Component } from 'react';
import Collapse from '@material-ui/core/Collapse';
import CircularProgress from '@material-ui/core/CircularProgress';
import JobsOperationsApiHandler from './../../JobsOperationsApiHandler.js';
import ErrorBox from './../../../../commons/ErrorBox';


export default class SortingSlot extends Component {
	constructor(props) {
		super(props);
		this.state = {
			open:false,
			slotInfo: null,
			showLoader: false,
			change: true,
			error: null
		}
	}

	closeError = () => {this.setState({error: null})}

	//<!---------------------------- Opening the collapsed hubs (If already fetched otherwise fetching from backend) ----------------------------!>
	openHubs = () => {
		if(this.state.open) {
			this.setState({open:false})
		} else {
			if(this.state.slotInfo) {
				this.setState({open:true})
			} else {
				if(this.props.sortingType) {
					this.setState({showLoader:true})
				}
				let req = {
					dispatchSlotId: this.props.slot.dispatchSlotId,
					processPhases: this.props.sortingType.processPhases
				};
				JobsOperationsApiHandler.getHubsForSlot(req)
					.then(resp => {
						this.setState({slotInfo: resp,open: true})
					}).catch(error => {
						this.setState({error: error.error.error});
					}).finally(() => {
						this.setState({showLoader:false})
					})
			}
		}

	}

	//<!---------------------------- Fetching the trips for a hub in a slot ----------------------------!>
	fetchTripsForHubSlot(hub) {
		var dispatchSlot = this.state.slotInfo.dispatchSlotId;
		hub.showLoader = true;
		this.setState({change: true});
		let req = {
			dispatchSlotId: dispatchSlot,
			hubId: hub.hubId,
			processPhases: this.props.sortingType.processPhases
		};
		JobsOperationsApiHandler.getTripsForHubAndSlot(req)
			.then(resp => {
				this.props.showGenerations(resp);
			}).catch(error => {
				this.setState({error: error.error.error});
			}).finally(() => {
				hub.showLoader = false;
			})
	}

	//<!---------------------------- Gettong the data for hubs(Render) ----------------------------!>
	getHubsData() {
		var hubsData;
		if(this.state.slotInfo) {
			hubsData = this.state.slotInfo.jobGenerationStatusForHubs.map((hub,index) => {
				if(hub.showLoader === undefined) {
					hub.showLoader = false;
				}
				return (<div className="dispatching-slot-hub" key={index} onClick={() => {this.fetchTripsForHubSlot(hub);}}>
							<div className="row" style={{lineHeight:'20px'}}>
								<div className="col-md-2 col-sm-2 col-xs-6 no-right-padding">
									{hub.hubName}
								</div>
								<div className="col-xs-6 visible-xs">
									<div className="row dispatch-slot-action">
										<div className="col-xs-4">
											{(hub.showLoader)?
												<CircularProgress style={{color:'#000',lineHeight:'18px'}} size={18} thickness={3} />:null
											}
										</div>
										<div className="col-xs-4 task-start-text">
											Start
										</div>
										<div className="col-xs-4">
											<i className="fas fa-chevron-circle-right twenty-font"></i>
										</div>
									</div>
								</div>
								<div className="col-md-7 col-sm-6 col-xs-12">
								{
									// <div className="row">
									// 	<div className="col-md-7 col-sm-11 col-xs-12 no-padding thirteen-font">
									// 		<span className="opacity-text">Pending Sorting Job Generation:</span> {hub.numTrips - hub.numTripsSortingGenerated} / {hub.numTrips}
									// 	</div>
									// 	<div className="col-md-5 col-sm-11 col-xs-12 no-padding thirteen-font">
									// 		<span className="opacity-text">Sorting Job Generated:</span> {hub.numTripsSortingGenerated} / {hub.numTrips}
									// 	</div>
									// </div>
								}
								</div>
								<div className="col-md-3 col-sm-4 hidden-xs">
									<div className="row dispatch-slot-action">
										<div className="col-md-4 col-sm-4 col-xs-3">
											{(hub.showLoader)?
												<CircularProgress style={{color:'#000',lineHeight:'18px'}} size={18} thickness={3} />:null
											}
										</div>
										<div className="col-md-3 col-sm-3 col-xs-3">
											
										</div>
										<div className="col-md-2 col-sm-2 col-xs-2 task-start-text">
											Start
										</div>
										<div className="col-md-3 col-sm-3 col-xs-3">
											<i className="fas fa-chevron-circle-right twenty-font"></i>
										</div>
									</div>
								</div>
							</div>
						</div>);
			}) 
		}
		return hubsData;
	}

	render() {
		return (
			<div>
				<div className="dispatch-slot-outer-newer">
					<div style={{padding:'20px',cursor:'pointer'}} onClick={this.openHubs}>
						<div className="slot-name-box-out">
							<div className="row">
								<div className="col-md-9 col-sm-9 col-xs-8">
									<div className="dispatch-slot-title">
									{this.props.slot.dispatchName} 
									<span style={{opacity:'0.5',marginLeft:'5px'}}>({this.props.sortingType.sortingTypeDescription})</span>
									</div>
								</div>
								<div className="col-md-3 col-sm-3 col-xs-4" style={{lineHeight:'20px'}}>
									<div className="row dispatch-slot-action">
										<div className="col-md-4 col-sm-4 col-xs-3" style={{textAlign:'right'}}>
										{(this.state.showLoader)?
											<CircularProgress style={{color:'#000',lineHeight:'20px'}} size={20} thickness={3} />:null
										}
										</div>
										<div className="col-md-4 col-sm-3 col-xs-3">
											<i className="fas fa-chevron-circle-right twenty-font"></i>
										</div>
										<div className="col-md-4 col-sm-3 col-xs-3">
										{(this.state.open)?
											<i className="fas fa-angle-up eighteen-font"></i>
											:
											<i className="fas fa-angle-down eighteen-font"></i>
										}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<Collapse in={this.state.open}>
						<div style={{padding:'5px 21px'}}>
							{this.getHubsData()}
						</div>
					</Collapse>
				</div>
				{(this.state.error)?
		 			<ErrorBox errorText={this.state.error} closeError={this.closeError}/>:null
    			}
			</div>
		)
	}
}




// WEBPACK FOOTER //
// ./src/screens/JobOperations/Components/Commons/SortingSlot.js